import {createApp} from 'vue'
import Antd from 'ant-design-vue'
import App from './MainLayout.vue'
import './registerServiceWorker'
import {router} from "@/app";
import 'ant-design-vue/dist/reset.css'
import {publish, reg} from "@/lib/session";
import emit from "@/lib/emit";
import duration from "dayjs/plugin/duration";
import dayjs from "dayjs";
import '@/lib/array.extension'
import {setupMock} from "@/lib/util";
import VueLazyload from "vue-lazyload";

setupMock()

dayjs.extend(duration)
const app = createApp(App).use(Antd).use(VueLazyload, {
    preLoad: 1.3,
    loading: require('@/assets/image/loading_template.gif'),
    attempt: 1
})
reg(() => app.use(router).mount('#app'))

document.addEventListener('click', (evt: MouseEvent) => {
    const el = evt.target as HTMLElement
    let c = `<${el.tagName} `
    el.getAttributeNames().forEach((name: string) => c += `${name}="${el.getAttribute(name)}" `)
    if (el.innerText === undefined) c += `</${el.tagName}>`
    else c += `>${el.innerText.substring(0, 30) == '' ? el.innerHTML.substring(30) : el.innerText.substring(0, 30).replace(/[\r\n]/g, "")}</${el.tagName}>`
    publish('click', c)
}, false)

window.addEventListener('resize', (evt) => emit.emit('window.resize', evt))